module.exports = __webpack_public_path__ + "assets/img/7.973a48d4.png";